import React from 'react';
import { _cs } from '@togglecorp/fujs';
import { genericMemo } from '../../utils/index.js';
import useUiModeClassName from '../../hooks/useUiModeClassName.js';
import styles from './styles.css.js';

function InputBorder(props) {
  const {
    className,
    uiMode,
    errored
  } = props;
  const uiModeClassName = useUiModeClassName(uiMode, styles.light, styles.dark);
  return /*#__PURE__*/React.createElement("div", {
    className: _cs(styles.inputBorder, uiModeClassName, errored && styles.errored, className)
  });
}

var InputBorder$1 = genericMemo(InputBorder);

export { InputBorder$1 as default };
//# sourceMappingURL=index.js.map
